import Swiper from 'swiper';

export default () => {
  const relatedProducts = document.querySelector('.js-single-product-related-slider');
  if (relatedProducts) {
    let initSlider = new Swiper(relatedProducts, {
      slidesPerView: 1,
      centeredSlides: true,
      // autoplay: {
      //   disableOnInteraction: false,
      // },
      longSwipesMs: 1000,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1023: {
          slidesPerView: 3,
        },
      },
      on: {
        resize: function (swiper) {
          swiper.slides.forEach(element => {
            // element.querySelector('.ProductCard__Wrapper').style.height = "200px"
            let imageHeight = +element.querySelector('.ProductCard__Image').scrollHeight;
            let bottomHeight = +element.querySelector('.ProductCard__Bottom').dataset.height;
            let total_height = imageHeight + bottomHeight;
            element.querySelector('.ProductCard__Wrapper').style.height = total_height + "px";
          });
        },
      },
    });

    enlargeBottom(initSlider, initSlider.activeIndex);

    initSlider.on('slideChangeTransitionEnd', function (i) {
      initSlider.slides.forEach(item => {
        let bottom = item.querySelector('.ProductCard__Bottom');
        bottom.style.visibility = 'hidden';
        bottom.style.height = '0px';
      });
      enlargeBottom(initSlider, i.activeIndex);
    });
  }

  function enlargeBottom(slider,current) {
    setTimeout(() => {
      let bottom = slider.slides[current].querySelector('.ProductCard__Bottom');
      bottom.style.visibility = 'visible';
      bottom.style.height = bottom.dataset.height+'px';
    }, 100);
  }

  const scrollProductImage = document.querySelector('.ProductIntroImage.DesktopOnly');
  const breadCrumbs = document.querySelector('.BreadCrumbs');
  if (scrollProductImage) {
    const scrollProductImage_wrapper = document.querySelector('.ProductIntro__Image');
    const ingredientsBg = document.querySelector('.Ingredients__Image');
    productImageAnimation(scrollProductImage,scrollProductImage_wrapper, ingredientsBg, breadCrumbs)
    window.addEventListener('scroll', () => {
      productImageAnimation(scrollProductImage,scrollProductImage_wrapper, ingredientsBg, breadCrumbs)
    })
  }

  function productImageAnimation(prodImg, prodImgContainer, ingredientsBgSection, breadCrumbs) {
    let breadCrumbsTotHeight = 0;
    if (breadCrumbs) {
      let breadCrumbsHeight = breadCrumbs.clientHeight;
      let breadCrumbsMarginBottom = parseInt(getComputedStyle(breadCrumbs).marginBottom);
      let breadCrumbsMarginTop = parseInt(getComputedStyle(breadCrumbs).marginTop);
      breadCrumbsTotHeight = breadCrumbsHeight + breadCrumbsMarginBottom + breadCrumbsMarginTop;
    }

    let headerHeight = document.querySelector('.js-header').clientHeight;
    let prodImgDrops = prodImgContainer.querySelector('.ProductIntroImage__Drops');
    let prodImgCircle = prodImgContainer.querySelector('.ProductIntroImage__Circle');
    let productImgHeight = prodImg.clientHeight;
    let ingredientsBgSectionHeight = ingredientsBgSection.clientHeight;
    let elDistanceToTop = window.pageYOffset + ingredientsBgSection.getBoundingClientRect().top + ((ingredientsBgSectionHeight - productImgHeight) / 2) - headerHeight;
    prodImgContainer.style.height = prodImg.clientHeight+'px';

    
    if (window.pageYOffset > 0 ) {
      if (window.pageYOffset > elDistanceToTop) { 
        prodImg.classList.add('is-absolute');
        prodImg.style.top = (elDistanceToTop+headerHeight+breadCrumbsTotHeight)+'px';
      } else {
        let opacity = 1 - ((window.pageYOffset / elDistanceToTop) * 2);
        prodImgDrops.style.opacity = opacity;
        prodImgCircle.style.opacity = opacity;
        prodImg.classList.remove('is-absolute');
        prodImg.style.top = (headerHeight+breadCrumbsTotHeight)+'px';
        // prodImg.style.top = (headerHeight + (headerHeight * (1 - (1 - (window.pageYOffset / elDistanceToTop)))))+'px';
      }
    } else if (!document.body.classList.contains('is-scrolled')) {
      prodImg.style.top = 0;
      prodImgDrops.style.opacity = 1;
      prodImgCircle.style.opacity = 1;
    }
  }
}